module.exports = __webpack_public_path__ + "img/MySpaceBrand.467a9489.svg";